<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!packingSlip">
    <div class="card">
        <div class="card-body p-2 pb-3">
            <div class="btn-toolbar mx-0 mb-1 mt-0">
                <div>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-secondary me-2" (click)="print()">Print Pack Slip</button>
                </div>
            </div>

            <dx-form *ngIf="packingSlip" [formData]="packingSlip" [colCount]="12" [readOnly]="true">
                <dxi-item itemType="group" [colSpan]="3">
                    <dxi-item dataField="deliveryMethod" [label]="{ text: 'Delivery Method' }"></dxi-item>
                    <dxi-item dataField="dealer.companyName" [label]="{ text: 'Dealer' }"></dxi-item>
                    <dxi-item dataField="packingSlipNumber" [label]="{ text: 'Slip #' }"></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="3">
                    <dxi-item
                        dataField="freight"
                        [label]="{ text: 'Freight' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: { type: 'currency', precision: 2 } }"
                    ></dxi-item>
                    <dxi-item dataField="createDate" [label]="{ text: 'Date' }"></dxi-item>
                    <dxi-item [label]="{ text: 'Shipping Notes' }" editorType="dxTextArea" dataField="note" [editorOptions]="{ height: '100' }"> </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="row" style="min-height: 300px">
        <div class="col-sm-9" style="padding-right: 0px">
            <div class="m-2">
                <dx-data-grid
                    #linesGrid
                    keyExpr="id"
                    class="lines-grid"
                    [dataSource]="orderLineDetails"
                    height="600"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    [sorting]="'none'"
                    [showBorders]="true"
                >
                    <dxi-column dataField="invoice.invoiceNumber" caption="Invoice" width="65" cellTemplate="invoiceTemplate"></dxi-column>
                    <dxi-column dataField="orderLine.partNumber" caption="Part #" width="200" cellTemplate="partTemplate"></dxi-column>
                    <dxi-column dataField="orderLine.description" width="200"></dxi-column>
                    <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
                    <dxi-column dataField="price" caption="Price" width="120" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                    <dxi-column dataField="vIN" caption="VIN #" width="165" [allowEditing]="false"></dxi-column>
                    <dxi-column></dxi-column>

                    <div *dxTemplate="let cell of 'invoiceTemplate'">
                        <a [routerLink]="[]" (click)="openInvoice(cell.value)">{{ cell.value || '' }}</a>
                    </div>

                    <div *dxTemplate="let cell of 'partTemplate'">
                        <div class="parent-part-number" *ngIf="cell.data.orderLine.partId && !cell.data.orderLine.parentLineId && !cell.data.orderLine.isReplacement">{{ cell.value }}</div>
                        <div class="replacement-part-number" *ngIf="cell.data.orderLine.isReplacement">{{ cell.value }}</div>
                        <div class="misc-part-number" *ngIf="!cell.data.orderLine.partId && !cell.data.orderLine.isReplacement">{{ cell.value }}</div>
                        <div class="option-part-number" *ngIf="cell.data.orderLine.parentLineId">{{ cell.value }}</div>
                    </div>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>

                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-state-storing [enabled]="true" [storageKey]="'payment-detail-grid'"></dxo-state-storing>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
